<script setup lang="ts">

import { ref } from "vue";
const isExpanded = ref( false );
const isHovered = ref( false );

</script>

<template>

    <div>
        <div class="flex items-center cursor-pointer" 
             @click="isExpanded = !isExpanded"
             @mouseenter="isHovered = true" 
             @mouseleave="isHovered = false">
             <div class="flex-1">
                <slot name="title" :isHovered="isHovered" :isExpanded="isExpanded" />
             </div>
             <div class="absolute right-3">
                <ExpandButton v-model="isExpanded" class="pointer-events-none text-2xl"/>
             </div>
        </div>
        <div class="hidden" :class="{ '!block': isExpanded }">
            <slot :isHovered="isHovered" :isExpanded="isExpanded" />
        </div>
    </div>

</template>
